import React from 'react';

const EmptyStateFolderIcon = ({ width = 185, height = 114, style }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 185 114"
        fill="none"
        style={style}
    >
        <path
            d="M26.375 80C10.3569 83.5947 0.5 88.4916 0.5 93.8884C0.5 104.921 41.6898 113.864 92.5 113.864C143.31 113.864 184.5 104.921 184.5 93.8884C184.5 88.4916 174.643 83.5947 158.625 80V88.708C158.625 94.7664 154.83 99.7317 150.144 99.7317H34.8563C30.17 99.7317 26.375 94.7635 26.375 88.708V80Z"
            fill="black"
            fillOpacity="0.06"
        />
        <path
            d="M120.137 45.3155C120.137 40.7354 122.995 36.9543 126.54 36.9514H158.625V88.7082C158.625 94.7665 154.83 99.7319 150.144 99.7319H34.8562C30.17 99.7319 26.375 94.7637 26.375 88.7082V36.9514H58.46C62.0049 36.9514 64.8626 40.7268 64.8626 45.3069V45.3697C64.8626 49.9498 67.752 53.6482 71.294 53.6482H113.706C117.248 53.6482 120.137 49.9156 120.137 45.3355V45.3155Z"
            fill="black"
            fillOpacity="0.04"
            stroke="#D9D9D9"
        />
        <path
            d="M158.625 37.2664L129.455 4.44366C128.055 2.20639 126.011 0.85376 123.858 0.85376H61.1424C58.989 0.85376 56.9449 2.20639 55.5448 4.44081L26.375 37.2693"
            stroke="#D9D9D9"
        />
    </svg>
);

export default EmptyStateFolderIcon;
